var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcManagegroup(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "23px",
    viewBox: "0 0 27 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icManagegroup") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Messenger-Inbox---chating---Admin-Options",
    transform: "translate(-23.000000, -700.000000)",
    fillRule: "nonzero",
    stroke: "#333333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(8.000000, 528.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(16.000000, 167.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icManagegroup",
    transform: "translate(0.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3911133,11.4902344 L19.4577148,11.4902344 C19.6547852,12.0297852 19.7624512,12.6120605 19.7624512,13.2189453 L19.7624512,20.5260742 C19.7624512,20.7791016 19.7184082,21.0219727 19.6382812,21.2478516 L22.8346191,21.2478516 C24.0286133,21.2478516 24.9999512,20.2764648 24.9999512,19.0825195 L24.9999512,15.0990723 C25,13.1091797 23.3810547,11.4902344 21.3911133,11.4902344 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.23754883,13.2189941 C5.23754883,12.6120605 5.34521484,12.029834 5.54228516,11.4902832 L3.60888672,11.4902832 C1.61894531,11.4902832 0,13.1092285 0,15.0991699 L0,19.0826172 C0,20.2765625 0.971337891,21.2479492 2.16533203,21.2479492 L5.36171875,21.2479492 C5.2815918,21.0219727 5.23754883,20.7791504 5.23754883,20.526123 L5.23754883,13.2189941 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7100098,9.61010742 L10.2899902,9.61010742 C8.30004883,9.61010742 6.68110352,11.2290527 6.68110352,13.2189941 L6.68110352,20.526123 C6.68110352,20.924707 7.00424805,21.2479004 7.40288086,21.2479004 L17.5971191,21.2479004 C17.995752,21.2479004 18.3188965,20.9247559 18.3188965,20.526123 L18.3188965,13.2189941 C18.3188965,11.2290527 16.6999512,9.61010742 14.7100098,9.61010742 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,0.041015625 C10.1068359,0.041015625 8.15986328,1.98798828 8.15986328,4.38120117 C8.15986328,6.00449219 9.05581055,7.4222168 10.3789551,8.16655273 C11.006543,8.51958008 11.7300781,8.72133789 12.5,8.72133789 C13.2699219,8.72133789 13.993457,8.51958008 14.6210449,8.16655273 C15.9442383,7.4222168 16.8401367,6.00444336 16.8401367,4.38120117 C16.8401367,1.98803711 14.8931641,0.041015625 12.5,0.041015625 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.87880859,4.08637695 C3.08901367,4.08637695 1.63295898,5.54243164 1.63295898,7.33222656 C1.63295898,9.12202148 3.08901367,10.5780762 4.87880859,10.5780762 C5.3328125,10.5780762 5.76513672,10.4840332 6.15786133,10.3149902 C6.83686523,10.0226562 7.39672852,9.50517578 7.74316406,8.85698242 C7.98632812,8.40205078 8.1246582,7.88305664 8.1246582,7.33222656 C8.1246582,5.54248047 6.66860352,4.08637695 4.87880859,4.08637695 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1211914,4.08637695 C18.3313965,4.08637695 16.8753418,5.54243164 16.8753418,7.33222656 C16.8753418,7.88310547 17.0136719,8.40209961 17.2568359,8.85698242 C17.6032715,9.50522461 18.1631348,10.0227051 18.8421387,10.3149902 C19.2348633,10.4840332 19.6671875,10.5780762 20.1211914,10.5780762 C21.9109863,10.5780762 23.367041,9.12202148 23.367041,7.33222656 C23.367041,5.54243164 21.9109863,4.08637695 20.1211914,4.08637695 Z",
    id: "Path"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcManagegroup);
export default __webpack_public_path__ + "static/media/icManagegroup.eae76bb45d82977854ba9e99fadec94a.svg";
export { ForwardRef as ReactComponent };